/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

import Vue from 'vue';
import Vuex from 'vuex';
import UAParser from 'ua-parser-js';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/browser';

Vue.use(Vuex);

const state = {
  phoneType: 'ocardw',
  os: new UAParser().getOS().name + new UAParser().getOS().version,
  deviceName: (new UAParser().getDevice().vendor || '') + (new UAParser().getDevice().name || ''),
  dtk: Cookies.get('dtk') || null,
  utk: Cookies.get('utk') || null,
};

const mutations = {
  setDtk(state, dtk) {
    state.dtk = dtk;
    if (process.env.NODE_ENV === 'development') {
      Cookies.set('dtk', dtk, { expires: 3560 });
    } else if (window.location.hostname === 'uat.ocard.co') {
      Cookies.set('uat_dtk', dtk, { expires: 3560, domain: '.ocard.co' });
    } else {
      Cookies.set('dtk', dtk, { expires: 3560, domain: '.ocard.co' });
    }
  },
  setUtk(state, utk) {
    state.utk = utk;
    Sentry.configureScope((scope) => {
      scope.setUser({ id: utk });
    });
  },
  clearUtk(state) {
    state.utk = null;
    Cookies.remove('utk', { domain: 'ocard.co' });
    Cookies.remove('utk', { domain: '.ocard.co' });
    Cookies.remove('utk');

    if (window.location.hostname === 'uat.ocard.co') {
      Cookies.remove('uat_utk', { domain: 'ocard.co' });
      Cookies.remove('uat_utk', { domain: '.ocard.co' });
      Cookies.remove('uat_utk');
    }
  },
};

export default {
  state,
  mutations,
};
